// src/config.js
export const MAX_FILES = 9;
